import OptionRowStyles from './types';
import styles from '../styles';

const compactContentContainerStyles: OptionRowStyles = styles.alignItemsBaseline;

export {
    // eslint-disable-next-line import/prefer-default-export
    compactContentContainerStyles,
};
